<template>
    <div>

        <div class="page_title">
            角色管理
        </div>
        <el-card
            :body-style="{
                textAlign: 'left',
                padding: '15px',
                height: '100%'
            }"
            shadow="never">
            <div class="header_btn">
                <el-button class="btn" size="small" type="primary" @click="addRole()" plain>新增角色</el-button>
            </div>
            <el-table
                :data="roleList"
                row-key="code"
                v-loading="loading"
                ref="roleTable"
                :header-cell-style="{background:'#eef1f6',color:'rgba(0, 0, 0 ,.85)',fontSize:'14px', paddingLeft: '24px'}"
                :cell-style="{color:'rgba(0, 0, 0 ,.65)', padding: '16px 24px'}"
                :height="tableHeight"
                default-expand-all
                :tree-props="{children: 'children'}">
                <el-table-column
                    prop="name"
                    label="角色名称">
                </el-table-column>
                <el-table-column
                    width="200"
                    prop="remark"
                    label="角色描述">
                </el-table-column>
                <el-table-column width="300" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="lookUp(scope.row)">查看</el-button>
                        <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" @click="authorize(scope.row)">授权</el-button>
                        <el-button type="text" size="small" style="color:#d45c34;" @click="delRole(scope.row)">删除
                        </el-button>
                        <el-button type="text" size="small" :disabled="scope.row.level >= 11"
                                   @click="addSubRole(scope.row)">新增下级角色
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <empower></empower>
            <add-role @getMsg="getMsg"></add-role>
        </el-card>
    </div>
</template>

<script>
import empower from '@/views/setting/views/roleManage/components/empower';
import addRole from '@/views/setting/views/roleManage/components/addRole';
import {mapState, mapActions} from "vuex";

export default {
    components: {
        empower,
        addRole
    },
    computed: {
        ...mapState('roleManage', ['roleMsg'])
    },
    watch: {
        roleMsg: {
            handler(newVal) {
                this.loading = false;
                this.roleList = newVal;
                console.log(newVal);
            },
            deep: true
        }
    },
    data() {
        return {
            loading: false,
            roleForm: {
                roleName: ""
            },
            tableHeight: 50,
            roleList: []
        }
    },
    mounted() {
        setTimeout(() => {
            this.tableHeight = window.innerHeight - 220;
        }, 100)
        window.addEventListener('resize', this.setHeight);
        this.getMsg();
        console.log(this)
    },
    destroyed() {
        window.removeEventListener('resize', this.setHeight);
    },
    methods: {
        ...mapActions('roleManage', ['roleTree', 'deleteRole']),

        setHeight() {
            this.tableHeight = window.innerHeight - 220;
        },
        getMsg() {
            this.loading = true;
            this.roleTree()
        },
        lookUp(row) {
            console.log(row);
            this.$store.commit("roleManage/SET_ADD_ROLE_TYPE", 4);
            this.$store.commit("roleManage/SET_ARR_ROLE_DIALOG_VISIBLE", true);
            this.$store.commit("roleManage/SET_ROLE_MSG_ITEM", row);
        },
        edit(row) {
            console.log(row);
            this.$store.commit("roleManage/SET_ADD_ROLE_TYPE", 3);
            this.$store.commit("roleManage/SET_ARR_ROLE_DIALOG_VISIBLE", true);
            this.$store.commit("roleManage/SET_ROLE_MSG_ITEM", row);
        },
        authorize(row) {
            console.log(row);
            this.$store.commit("roleManage/SET_EMPOWER_DRAWER_VISIBLE", true);
            this.$store.commit("roleManage/SET_ROLE_MSG_ITEM", row);
        },
        delRole(row) {
            console.log(row);
            this.$dialog.showConfirm({
                content: "删除该角色，角色下的用户也会被删除确认要删除吗？",
                title: "删除",
                btn1: "确认",
                btn2: "取消",
                icon: 2
            }, () => {
                this.deleteRole({
                    code: row.code
                }).then(res => {
                    console.log(res);
                    this.$dialog.showMessage("删除成功", this.$config.TOAST_SUCCESS);
                    this.getMsg();
                }, err => {
                    console.log(err);
                    this.$dialog.showMessage(err.resultMsg ? err.resultMsg : '请求错误', this.$config.TOAST_ERROR);
                })
            }, () => {
            })
        },
        addSubRole(row) {
            console.log(row);
            this.$store.commit("roleManage/SET_ADD_ROLE_TYPE", 2);
            this.$store.commit("roleManage/SET_ARR_ROLE_DIALOG_VISIBLE", true);
            this.$store.commit("roleManage/SET_ROLE_MSG_ITEM", {
                parentRoleName: row.name,
                parentCode: row.code
            });
        },
        handleCurrentChange(page) {
            console.log(page)
        },
        addRole() {
            this.$store.commit("roleManage/SET_ADD_ROLE_TYPE", 1);
            this.$store.commit("roleManage/SET_ARR_ROLE_DIALOG_VISIBLE", true);
        }
    },
}
</script>

<style scoped>

.el-card {
    border: none;
    border-radius: 8px;
    margin: 60px 20px 20px 20px;
}

.member_table {
    padding-top: 10px;
    border-radius: 4px 4px 0 0;
}

.el-input {
    width: 200px;
}

/deep/ .el-breadcrumb__inner, /deep/ .el-breadcrumb__separator {
    font-weight: bold !important;
    font-size: 16px !important;
    color: black !important;
}

.header_btn {
    width: 100%;
    margin-bottom: 10px;
}

.btn {
    float: right;
    margin-bottom: 10px;
}

/deep/ .el-table__header-wrapper {
    border-radius: 8px 8px 0 0;
}

/deep/ .cell {
    padding: 0 !important;
}
</style>
